const newMoneyMgmtTest =
 {
    user: "studentX",
    nbrGameMonths: "337",
    testVersion: "1.0",
    nbrCorrect: 10,
    nbrQuestions: 10,
    questionAnswerArr: [{questionNbr: "1", text: "questionText", answerArr: ["a","b"], correct: true}],
};
export default newMoneyMgmtTest;